import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Nav from "@/components/Nav";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import Evaluate from "@/pages/Evaluate";
import Result from "@/pages/Result";
import History from "@/pages/History";
import Compare from "@/pages/Compare";
import Zones from "@/pages/Zones";
import Appraisal from "@/pages/Appraisal";
import Pricing from "@/pages/Pricing";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Nav />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/evaluare" element={<Evaluate />} />
          <Route path="/rezultat/:id" element={<Result />} />
          <Route path="/istoric" element={<History />} />
          <Route path="/comparatie" element={<Compare />} />
          <Route path="/preturi-zone" element={<Zones />} />
          <Route path="/evaluare-profesionala" element={<Appraisal />} />
          <Route path="/preturi" element={<Pricing />} />
          <Route path="/plata/succes" element={<PaymentSuccess />} />
          <Route path="/plata/anulat" element={<PaymentCancel />} />
        </Routes>
        <Footer />
        <Toaster position="bottom-right" />
      </BrowserRouter>
    </div>
  );
}
